import React, {Component} from 'react';
import { connect }              from 'react-redux';
import Progress from './progress.js'

class footer extends Component {
   
    render() {
        const pontuacao = this.props.session.pontuacao;
     
        return (
                   <section className="hud-bottom">
            <aside className="hud-bottom-aside">
                <a href="javascript:void(0)">

                </a>
            </aside>
            <div className="hud-bottom-center">
                <div className="hud-bottom-center-side">
                    <div className="hud-label">Nível</div>
                    <div className="hud-value nivel">{pontuacao.pon_ger_nivel}</div>
                </div>
                <div className="hud-bottom-center-content" id="progress-container">
                    <div className="hud-label" id="progress-label">100%</div>
                    <Progress/>
                </div>
                <div className="hud-bottom-center-side">
                    <div className="hud-label">Pontos</div>
                    <div className="hud-value pontos">{pontuacao.pon_ger_pontos}</div>
                </div>
            </div>
            <aside className="hud-bottom-aside">
                <a href="javascript:void(0)">

                </a>
            </aside>
        </section>
        );
    }
}


function mapStateToProps(state){

    return {  
             session     : state.auth.session,
           }
}


export default connect(mapStateToProps)(footer);



// WEBPACK FOOTER //
// ./src/components/aluno/footer/footer.js